module.exports = __webpack_public_path__ + "img/news.1506b3f5.jpg";